export default "__VITE_ASSET__DcEShHz9__"